import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/public/xuehui.png'
import _imports_1 from '../../assets/public/xiehui.png'


const _hoisted_1 = { class: "headerContent" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "top-p" }
const _hoisted_4 = { class: "desktop-only" }
const _hoisted_5 = { class: "main-content" }
const _hoisted_6 = { class: "desktop-search-container desktop-only" }
const _hoisted_7 = { class: "mobile-search-container" }

import { getNow, now } from '@/utils/getTime';
import { ref, onMounted, watch} from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'header',
  setup(__props) {

const isMobile = ref(false);
// 修改检测移动端的逻辑
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768; // 改为768px及以下才认为是移动端
};

// 搜索框与路由
const router = useRouter();
const searchValue = ref('');
const hasShownEmptyWarning = ref(false);

// 监听路由变化，离开当前页时清空搜索框
watch(() => router.currentRoute.value.path, (newPath) => {
  if (newPath !== '/search') { // 如果不是跳转到搜索页
    searchValue.value = '';
  }
});

const handleSearch = () => {
  const keyword = searchValue.value.trim();
  
  if (!keyword) {
    if (!hasShownEmptyWarning.value) {
      ElMessage.warning('请输入搜索内容');
      hasShownEmptyWarning.value = true;
      
      setTimeout(() => {
        hasShownEmptyWarning.value = false;
      }, 3000);
    }
    return;
  }
  
  hasShownEmptyWarning.value = false;
  
  try {
    router.push({
      path: '/search',
      query: { keyword }
    });
  } catch (error) {
    ElMessage.error('搜索跳转失败');
    console.error('搜索跳转错误:', error);
  }
};

onMounted(() => {
  getNow();
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _cache[2] || (_cache[2] = _createTextVNode("山东省神经科学学会   山东省阿尔茨海默病防治协会，欢迎您！  ")),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(now)), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "hover-p desktop-only" }, [
        _createElementVNode("a", {
          href: "https://member.tiemeeting.com/3/Mpersonal/Account/Login",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "会员登录"),
        _createElementVNode("span", { style: {"color":"#fff"} }, "   |   "),
        _createElementVNode("a", {
          href: "http://sdssjkxxh.com:8080/",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "管理员登录")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bottom" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }),
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        })
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_input, {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
          placeholder: "请输入要搜索内容",
          clearable: "",
          onKeyup: _withKeys(handleSearch, ["enter"])
        }, {
          append: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: handleSearch,
              type: "primary"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("搜索")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_input, {
        modelValue: searchValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchValue).value = $event)),
        placeholder: "请输入要搜索内容",
        clearable: "",
        onKeyup: _withKeys(handleSearch, ["enter"])
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_button, {
            onClick: handleSearch,
            type: "primary"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("搜索")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 512), [
      [_vShow, isMobile.value]
    ])
  ]))
}
}

})